import { render } from "./EventsListPage.vue?vue&type=template&id=7bccc392&scoped=true"
import script from "./EventsListPage.vue?vue&type=script&lang=js"
export * from "./EventsListPage.vue?vue&type=script&lang=js"

import "./EventsListPage.vue?vue&type=style&index=0&id=7bccc392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bccc392"]])

export default __exports__